import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import { Modal, Form, Button, Row } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { FaPlusSquare, FaMinusSquare } from "react-icons/fa";

import { endPoints } from "../../../constant/Environment";
import Loader from "../../../components/Loader";
import { getAllData } from "../../../Utility/API";

const DashboardGameList = ({ userId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [gamelist, setGameLisst] = useState([]);

  function checkWin(winAmount, betAmount) {
    const result = winAmount - betAmount;
    return result >= 0;
  }

  const getGamePlayList = (type) => {
    setIsLoading(true);
    let url = `${endPoints.api.DASHBOARD_GAME_LIST}/${userId}/0/500`;
    getAllData(url)
      .then((response) => {
        setIsLoading(false);
        const { status, data, message } = response;
        if (status === "success") {
          setGameLisst(data);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    //  type 2 means - saga coin 1 means gold coin
    getGamePlayList(2);
  }, []);

  const exportCsv = () => {

    setIsLoading(true);
    // usertransaction/3402/0/1000/download/csv
    fetch(
      `${
        endPoints.apiBaseUrl + `usertransaction/${userId}/0/10000/download/csv`
      }`,
      {
        method: "GET",
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          SessonId: sessionStorage.getItem("session")?.replace('"', "").replace('"', ""),
        },
      }
    ).then(function (response) {
      setIsLoading(false);
      response.blob().then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "TransactionReport.csv";
        link.click();
      });
    });
  };



  return (
    <>
      {isLoading && <Loader spinner={true} visible={isLoading} />}
      <div style={{ display: "flex",marginTop:'10px' }}>
              {/* <h4 className="dark-gray f-bold mb-4">Transactions</h4> */}
              <Button className="exportbtn" onClick={() => exportCsv()}>
                <img src="/images/icons/csv.png" />
              </Button>
            </div>
      <div className="col-md-12">
        <div className="custom-table-data mt-4">
          {/* <div style={{ display: "flex" }}>
            <h4 className="dark-gray f-bold" style={{ marginTop: "14px" }}>
              Play Game List{" "}
            </h4>
            <Button className="exportbtn" onClick={() => exportPdf()}>
              <img src="/images/icons/pdf.png" />
            </Button>
            <Button className="exportbtn" onClick={() => exportCsv()}>
              <img src="/images/icons/csv.png" />
            </Button>
            <Button
              onClick={() => {
                getGamePlayList(1);
              }}
              variant="primary"
              style={{ marginBottom: "5px" }}
            >
              Gold Coin
            </Button>
            <Button
              onClick={() => {
                getGamePlayList(2);
              }}
              variant="primary"
              style={{ marginBottom: "5px", marginLeft: "10px" }}
            >
              Saga Coin
            </Button>
          </div> */}

          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="center">Game </TableCell>
                  <TableCell align="center"> Bet Amount </TableCell>
                  <TableCell align="center">Win Amt </TableCell>
                  <TableCell align="center">Win/Loss </TableCell>
                  <TableCell align="center">Balance </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gamelist?.length > 0 &&
                  gamelist.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {moment(row.created_on).format("MM/DD/YYYY")}
                      </TableCell>
                      <TableCell align="center">{row.gameName}</TableCell>

                      <TableCell align="center">
                        {row.betamount.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        {row.winamount.toFixed(2)}
                      </TableCell>
                      <TableCell align="center">
                        {checkWin(
                          parseFloat(row.winamount),
                          parseFloat(row.betamount)
                        ) ? (
                          <span
                            style={{
                              color: "green",
                              //   display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <FaPlusSquare
                              color="green"
                              style={{ marginRight: "5px" }}
                            />
                            {`${(
                              parseFloat(row.winamount) -
                              parseFloat(row.betamount)
                            ).toFixed(2)}`}
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "red",
                              //   display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <FaMinusSquare
                              color="red"
                              style={{ marginRight: "5px" }}
                            />
                            {`${(
                              parseFloat(row.winamount) -
                              parseFloat(row.betamount)
                            ).toFixed(2)}`}
                          </span>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {row.balance.toFixed(2)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default DashboardGameList;
